import { TFunc } from '@Translations/types';

export const getObservationFields = (
	t: TFunc,
): { label: string; value: string; disabled: boolean }[] => {
	return [
		{
			label: t('Code'),
			value: 'PACP_CODE',
			disabled: false,
		},
	];
};
